import { useNavigate } from "react-router-dom";
import { useLocation } from "react-router-dom";
import { Fragment, useEffect } from "react";
import Vaspianlogo from "../../../../utils/images/vaspianlogo.png";
// import { useKeycloak } from "@react-keycloak/web";
import { Menu, Transition } from "@headlessui/react";
import { useTheme } from "../../../../theme/themeContext";
import { useTranslation } from "react-i18next";
import jwtDecode from "jwt-decode";
import { useState } from "react";
import { getENVData } from "../../../../config/environment";
import { useDispatch, useSelector } from "react-redux";
import { setUserRoles } from "../../../../toolkit/reducers/authSlice";
import SearchBar from "../../../../atom/search";
import { Cookies } from "react-cookie";

import {
  CloseIcon,
  QuestionMarkIcon,
  topBarBellIcon,
  topBarSettingsIcon,
} from "../../../../utils/icons/defaultIcons";
import {
  getAppServerTenants,
  getTenantPermission,
  getTenantUserDetails,
  getTenantsList,
  getUserPermission,
} from "../../../../services/api";
import Notification from "../../../../atom/Notification";
import UserProfile from "../../../../containers/modal/userProfile";
import FadeIn from "react-fade-in/lib/FadeIn";
import { tenantsMenu } from "../../../../toolkit/reducers/tenantsListSlice";
import { useAuth } from "../../../../containers/authv2/authClient";
import Loader from "../../../../containers/loader";
import {
  setPermissionStatus,
  setPermissions,
} from "../../../../toolkit/reducers/permissionSlice";
import SimulationIdSlice, {
  setSimuation,
} from "../../../../toolkit/reducers/SimulationIdSlice";
import axios from "axios";
import { LeftMenuItems } from "../../../../config/leftMenuItems";
import { activeIndex } from "../../../../toolkit/reducers/tableButton1IndexSlice";
import { setCurrentUserData } from "../../../../toolkit/reducers/userDataSlice";
import { hasPermission } from "../../../../services/utilities";
import Lottiefy from "../../../../atom/lottie/lottie";
import * as loaderLottie from "../../../../utils/lottie/loaderLottie.json";
import LocalDb from "../../../../containers/authv2/indexedDB";
import { Tooltip } from "@mui/material";

function classNames(...classes: any[]) {
  return classes.filter(Boolean).join(" ");
}
const ToolBar = () => {
  const auth = useAuth();
  const cookies = new Cookies();

  const simulate = useSelector((state: any) => state.Simulation.simulate);
  const userData = useSelector((state: any) => state.currentUserData.data);
  const accountId = useSelector((state: any) => state.Permissions.accountId);
  const permissions = useSelector(
    (state: any) => state.Permissions.permissions
  );

  const accessToken = useSelector((state: any) => state.auth.accessToken);
  const { theme, toggleTheme } = useTheme();
  const [currentLanguage, setCurrentLanguage] = useState<any>({
    name: "English",
    key: "en",
  });
  const [userProfileModal, setUserProfileModal] = useState<boolean>(false);
  const [simulation, setSumulationMenu] = useState<boolean>(false);
  const [tenantDropdown, setTenantDropdown] = useState<boolean>(true);
  const [alphabets, setAlphabets] = useState<any>([]);
  const [alphabet, setAlphabet] = useState<any>("All");
  const [search, setSearch] = useState<string>("");
  const [loader, setLoader] = useState<boolean>(false);
  const [data, setData] = useState<any>([]);
  const [masterData, setMasterData] = useState<any>([]);
  const dispatch = useDispatch();

  const navigate = useNavigate();
  const { i18n } = useTranslation();
  const { t } = useTranslation();
  const navigation = useLocation();
  const navigateTo = (nav: string) => {
    const navItem = LeftMenuItems.control.find(
      (item: any) => item.item === nav
    );
    setTimeout(() => {
      if (navItem) {
        navigate(`app/${navItem.path}`, { replace: true });
      } else {
        navigate(`app/${nav}`, { replace: true });
      }
    }, 200);
  };
  const [resultNotFound, setResultNotFound] = useState<boolean>(false);

  const environment = getENVData();
  // const { keycloak } = useKeycloak();
  const languages = [
    {
      name: "English",
      key: "en",
    },
    {
      name: "French",
      key: "fr",
    },
    {
      name: "Spanish",
      key: "sp",
    },
  ];
  const changeTheme = () => {
    toggleTheme(theme === "light" ? "dark" : "light", () => {});
  };
  // const navigateTo = (nav: string) => {
  //   navigate(`/${nav}`, { replace: true });
  // };
  const handleSwitchLanguage = (language: any) => {
    i18n.changeLanguage(language.key);
    setCurrentLanguage(language);
  };

  const getAlphabets = () => {
    const alpha = Array.from(Array(26)).map((e, i) => i + 65);
    const alphabet = alpha.map((x) => String.fromCharCode(x));
    setAlphabets(alphabet);
  };

  const handleLogOut = async () => {
    if (getENVData().env === "localhost") {
      localStorage.clear();
    }
    const tokenStore = LocalDb.loadLocalDB("token", "TokenList", 2);
    LocalDb.clear(tokenStore, "TokenList");
    // await keycloak.logout();
    auth.signOut(() => {});
    sessionStorage.removeItem("simulation");
    // cookies.remove('simulation', { path: '/' })
    dispatch(setPermissions({}));
    dispatch(setPermissionStatus(0));
    navigate(`/app`, { replace: false });
  };

  function groupByNames(rawData: any) {
    let data = rawData.reduce((r: any, e: any) => {
      let group = e.displayname[0];
      if (!r[group]) r[group] = { group, children: [e] };
      else r[group].children.push(e);
      return r;
    }, {});
    return Object.values(data);
  }
  const getTenant = () => {
    setSearch("");
    if (tenantDropdown) {
      setLoader(true);
      getAppServerTenants("").then((result: any) => {
        if (result?.data?.length === 0) {
          setResultNotFound(true);
          setLoader(false);
        } else {
          setResultNotFound(false);
          setLoader(false);
        }
        dispatch(tenantsMenu(result));
        setMasterData([...result.data]);
        const grouped = groupByNames([...result.data]).sort(
          (a: any, b: any) => {
            return a.group > b.group ? 1 : -1;
          }
        );
        setData(grouped);
      });
    }
    getAlphabets();
  };
  const handlePermission = (data: any, node: any) => {
    var result: any = {};
    var initObject: any = "";
    data.map((item: any) => {
      Object.keys(item)?.map((key) => {
        result[key] = item[key];
        if (initObject === "" && key !== "undefined" && key !== "dashboard") {
          initObject = key;
        }
      });
    });
    if (initObject === "") {
      Notification("Oops!", "No Permissions found", "danger");
    } else {
      // navigateTo(`loader`);
      dispatch(setSimuation(node));
      // navigateTo(`${initObject}`);
      dispatch(setPermissions(result));
      navigateTo(`routing`);
    }
  };
  const closeSimulation = async (e: any) => {
    console.log("permissions", permissions);
    e.stopPropagation();
    setLoader(true);
    const data = await getUserPermission();
    handlePermission(data?.data, "");
    navigateTo(`routing`);
    sessionStorage.removeItem("simulation");
    // cookies.remove('simulation', { path: '/' })
    setLoader(false);
    // dispatch(setSimuation(""));
  };
  const handleSimulation = async (node: any) => {
    console.log("node", node);
    setLoader(true);
    window.sessionStorage.setItem("simulation", node.uuid);
    // cookies.set('simulation', node.uuid, { path: '/' });
    const data: any = await getTenantPermission(node.uuid);
    handlePermission(data?.data, node);
    setLoader(false);
  };
  const handleFilter = (alphabet: string) => {
    setAlphabet(alphabet);
  };
  const handleSearch = (str: string) => {
    setSearch(str);
    if (str === "") {
      setData(groupByNames(masterData));
      setResultNotFound(false);
    } else {
      const result = masterData.filter((item: any) => {
        return item.name.toLowerCase().includes(str.toLowerCase());
      });
      console.log(result, "resulttttt");
      if (result?.length === 0) {
        setResultNotFound(true);
      } else {
        setResultNotFound(false);
      }
      const grouped = groupByNames(result);
      setData(grouped);
    }
  };

  const handleKeyPress = () => {};
  // useEffect(() => {
  //   const currentAccount: any = accessToken;
  //   if (currentAccount) {
  //     const data: any = jwtDecode(currentAccount);
  //     if (data.azp === "vaspiantelco" || data.azp === "supertelco") {
  //       setSimulationPermission(true);
  //     }
  //   }
  // }, [accessToken]);
  useEffect(() => {
    getTenantUserDetails("").then((resultData: any) => {
      const result: any = resultData.data;
      console.log(result, "userdetails");
      dispatch(setCurrentUserData(result));
    });
    setSumulationMenu(
      hasPermission("simulation", "tenant_simulation", permissions)
    );
  }, []);
  return (
    <div className=" h-16 w-full bg-[white] flex px-6 items-center justify-between">
      {/* <svg
        className=" shrink-0"
        width="106"
        height="32"
        viewBox="0 0 106 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect width="106" height="32" fill="url(#pattern0)" />
        <defs>
          <pattern
            id="pattern0"
            patternContentUnits="objectBoundingBox"
            width="1"
            height="1"
          >
            <use
              href="#image0_457_8375"
              transform="matrix(0.005 0 0 0.0165625 0 -0.00515625)"
            />
          </pattern>
          <image
            id="image0_457_8375"
            width="200"
            height="61"
            href="data:image/png;base64,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"
          />
        </defs>
      </svg> */}

      <img src={Vaspianlogo} height={120} width={120}></img>

      {/* tenant dropdown */}
      <div className="flex item-center gap-4 justify-evenly">
        {simulation && !permissions?.simulation && (
          <Menu as="div" className="relative text-left flex flex-row">
            <div onClick={(e) => closeSimulation(e)}>
              <Menu.Button className="inline-flex w-full capitalize justify-center gap-x-1.5 rounded-md  px-3 py-2 ttext-gray-900 hover:bg-gray-50 ">
                <div
                  id={"tenant_simulate_button"}
                  className=" h-[44px] w-[300px] border border-[#595754] rounded-[10px] justify-between cursor-pointer mt-1  relative"
                >
                  <div className="mt-2 ml-2 text-left text-[#767676] font-bold w-[280px] group">
                    {loader ? (
                      <div className="flex text-primary">
                        <svg
                          aria-hidden="true"
                          className={`inline w-6 h-6 mr-2 text-gray-200 animate-spin dark:text-gray-600 fill-blue-600`}
                          viewBox="0 0 100 101"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                            fill="#ffead4"
                          />
                          <path
                            d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                            fill="#F8A244"
                          />
                        </svg>
                        Closing Simulation...
                      </div>
                    ) : (
                      <div>
                        <p className="truncate w-[250px]">
                          {simulate?.displayname ?? "Vaspian"}
                        </p>
                        {simulate?.displayname ? (
                          <div
                            className="float-right -mt-[24px]"
                            onClick={(e) => closeSimulation(e)}
                          >
                            <CloseIcon />
                          </div>
                        ) : (
                          <div className=" -mt-[27px] float-right  bg-[#FFEBD5] rounded-[10px] w-8 h-8 flex items-center justify-center">
                            <svg
                              width="12"
                              height="8"
                              viewBox="0 0 10 6"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                              className="group-hover:animate-bounce mt-0.5"
                            >
                              <path
                                d="M4.99989 5.27877L0.759521 1.03842L1.54989 0.248047L4.99989 3.69805L8.44989 0.248047L9.24026 1.03842L4.99989 5.27877Z"
                                fill="#1C1B1F"
                              />
                            </svg>
                          </div>
                        )}
                      </div>
                    )}
                  </div>
                </div>
              </Menu.Button>
            </div>
          </Menu>

          // previous tenant simulation code with dropdown
          // <Menu as="div" className="relative text-left flex flex-row">
          //   <div onClick={() => getTenant()}>
          //     <Menu.Button className="inline-flex w-full capitalize justify-center gap-x-1.5 rounded-md  px-3 py-2 ttext-gray-900 hover:bg-gray-50 ">
          //       <div
          //         id={"tenant_simulate_button"}
          //         className=" h-[44px] w-[300px] border border-[#595754] rounded-[10px] justify-between cursor-pointer mt-1  relative"
          //       >
          //         <div className="mt-2 ml-2 text-left text-[#767676] font-bold w-[280px] group">
          //           {loader ? (
          //             <div className="flex text-primary">
          //               <svg
          //                 aria-hidden="true"
          //                 className={`inline w-6 h-6 mr-2 text-gray-200 animate-spin dark:text-gray-600 fill-blue-600`}
          //                 viewBox="0 0 100 101"
          //                 fill="none"
          //                 xmlns="http://www.w3.org/2000/svg"
          //               >
          //                 <path
          //                   d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
          //                   fill="#ffead4"
          //                 />
          //                 <path
          //                   d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
          //                   fill="#F8A244"
          //                 />
          //               </svg>
          //               Simulating..
          //             </div>
          //           ) : (
          //             <div>
          //               <p className="truncate w-[250px]">
          //                 {simulate?.displayname ?? "Vaspian"}
          //               </p>
          //               {simulate?.displayname ? (
          //                 <div
          //                   className="float-right -mt-[24px]"
          //                   onClick={(e) => closeSimulation(e)}
          //                 >
          //                   <CloseIcon />
          //                 </div>
          //               ) : (
          //                 <div className=" -mt-[27px] float-right  bg-[#FFEBD5] rounded-[10px] w-8 h-8 flex items-center justify-center">
          //                   <svg
          //                     width="12"
          //                     height="8"
          //                     viewBox="0 0 10 6"
          //                     fill="none"
          //                     xmlns="http://www.w3.org/2000/svg"
          //                     className="group-hover:animate-bounce mt-0.5"
          //                   >
          //                     <path
          //                       d="M4.99989 5.27877L0.759521 1.03842L1.54989 0.248047L4.99989 3.69805L8.44989 0.248047L9.24026 1.03842L4.99989 5.27877Z"
          //                       fill="#1C1B1F"
          //                     />
          //                   </svg>
          //                 </div>
          //               )}
          //             </div>
          //           )}
          //         </div>
          //       </div>
          //     </Menu.Button>
          //   </div>
          //   <Transition
          //     as={Fragment}
          //     enter="transition ease-out duration-100"
          //     enterFrom="transform opacity-0 scale-95"
          //     enterTo="transform opacity-100 scale-100"
          //     leave="transition ease-in duration-75"
          //     leaveFrom="transform opacity-100 scale-100"
          //     leaveTo="transform opacity-0 scale-95"
          //   >
          //     <Menu.Items className="absolute right-3 z-[10000] mt-[50px] origin-top-right rounded-[10px] bg-white shadow-xl  focus:outline-none">
          //       <div className="absolute z-50 ml-4 2xl:w-[1165px] xl:w-[1165px] md:w-[700px] w-[400px]  h-fit pb-2  mt-4 px-5 right-0 top-[100%] rounded-lg bg-[#FFFFFF] shadow-xl">
          //         <FadeIn>
          //           <div className="font-bold text-[18px] mt-2">
          //             Search Tenants
          //           </div>
          //           <div className="mt-3 -ml-1">
          //             <SearchBar
          //               setSearchText={handleSearch}
          //               searchtext={search}
          //               placeholder="Search tenant name here..."
          //             />
          //           </div>

          //           {/* alphabetical search bar */}
          //           <div className="justify-between flex overflow-x-auto">
          //             <div
          //               onClick={() => handleFilter("All")}
          //               className={`cursor-pointer inline-block pt-[3px] text-center mt-3 h-[32px] w-[32px] overflow-x-auto border border-[#0000001F] rounded-[5px] space-x-2 ${
          //                 alphabet === "All" ? "bg-[#FEBA12]" : ""
          //               }`}
          //             >
          //               All
          //             </div>
          //             <div className="mt-3 space-x-2">
          //               {alphabets?.map((node: any, index: number) => {
          //                 return (
          //                   <div
          //                     onClick={() =>
          //                       data.filter((item: any) => item.group === node)
          //                         .length
          //                         ? handleFilter(node)
          //                         : null
          //                     }
          //                     className={`${
          //                       data.filter((item: any) => item.group === node)
          //                         .length
          //                         ? "cursor-pointer"
          //                         : "opacity-25 cursor-not-allowed"
          //                     } ${
          //                       alphabet === node ? "bg-[#FEBA12]" : ""
          //                     } inline-block text-center pt-[3px] h-[32px] w-[32px] border border-[#0000001F] rounded-[5px] space-x-2 hover:bg-[#FEBA12]`}
          //                   >
          //                     {node}
          //                   </div>
          //                 );
          //               })}
          //             </div>
          //             {/*  */}
          //           </div>
          //           <div className="mt-3">
          //             <hr />
          //           </div>

          //           <div className="h-[215px] 2xl:w-[1117px] xl:w-[1117px] md:w-[660px] mt-5">
          //             <div className="h-[215px] overflow-x-auto">
          //               {resultNotFound ? (
          //                 <div className="flex justify-center items-center -mt-2 h-full">
          //                   <p className="font-bold">No Results Found!</p>
          //                 </div>
          //               ) : (
          //                 <div className="flex w-[2000px]">
          //                   {data
          //                     .filter(
          //                       (item: any) =>
          //                         item.group === alphabet || alphabet === "All"
          //                     )
          //                     .map((node: any) => {
          //                       return (
          //                         <span className="block w-[340px]">
          //                           <span className=" bg-[#FEBA12] h-[32px] w-[32px] flex justify-center items-center rounded-[5px]">
          //                             {node.group}
          //                           </span>
          //                           <div className="mt-2">
          //                             {node.children.map((children: any) => {
          //                               return (
          //                                 <Menu.Item>
          //                                   <span
          //                                     onClick={() =>
          //                                       handleSimulation(children)
          //                                     }
          //                                     className="block hover:bg-ternary hover:font-bold hover:text-[#767676] rounded-lg cursor-pointer px-2 py-1"
          //                                   >
          //                                     {children?.displayname}
          //                                   </span>
          //                                 </Menu.Item>
          //                               );
          //                             })}
          //                           </div>
          //                         </span>
          //                       );
          //                     })}
          //                 </div>
          //               )}
          //             </div>
          //           </div>
          //         </FadeIn>
          //         {loader && (
          //           <div className="absolute z-[60] bg-[white] top-0 opacity-50 left-0 rounded-lg w-[100%] h-[399px] flex justify-center items-center">
          //             {/* <Loader /> */}
          //             <Lottiefy
          //               loop={true}
          //               json={loaderLottie}
          //               height={60}
          //               width={60}
          //             />
          //           </div>
          //         )}
          //       </div>
          //     </Menu.Items>
          //   </Transition>
          // </Menu>
        )}
        <Menu as="div" className="relative text-left flex flex-row ">
          {/* <div className=" justify-center gap-x-1.5 rounded-md  px-3 py-3 ttext-gray-900 hover:bg-gray-50 cursor-pointer">
            {topBarBellIcon()}
          </div>
          <div className=" justify-center gap-x-1.5 rounded-md  px-3 py-[11px] ttext-gray-900 hover:bg-gray-50 cursor-pointer">
            {topBarSettingsIcon()}
          </div> */}

          <div className="flex space-x-4">
            <Tooltip title={"Help and Feedback"}>
              <div
                className="flex justify-center items-center cursor-pointer mt-1"
                onClick={() =>
                  window.open("https://www.vaspiandocs.com", "_blank")
                }
              >
                <QuestionMarkIcon />
              </div>
            </Tooltip>
            <Menu.Button className="inline-flex w-full capitalize justify-center items-center mt-2 gap-x-1.5 rounded-md  px-3 py-2 ttext-gray-900 hover:bg-gray-50">
              <div>
                <button
                  type="button"
                  className="relative flex rounded-full bg-gray-800 text-sm focus:outline-none focus:ring-2 focus:ring-white focus:ring-offset-2 focus:ring-offset-gray-800"
                  id="user-menu-button"
                  aria-expanded="false"
                  aria-haspopup="true"
                >
                  <span className="absolute -inset-1.5"></span>

                  {/* <img
                    className="h-8 w-8 rounded-full"
                    src="https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80"
                    alt=""
                  /> */}
                  <div className="bg-[#E6E9F7] rounded-[50%] w-8  h-8 flex justify-center items-center">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="28"
                      height="28"
                      fill="#000000"
                      viewBox="0 0 256 256"
                    >
                      <path d="M230.92,212c-15.23-26.33-38.7-45.21-66.09-54.16a72,72,0,1,0-73.66,0C63.78,166.78,40.31,185.66,25.08,212a8,8,0,1,0,13.85,8c18.84-32.56,52.14-52,89.07-52s70.23,19.44,89.07,52a8,8,0,1,0,13.85-8ZM72,96a56,56,0,1,1,56,56A56.06,56.06,0,0,1,72,96Z"></path>
                    </svg>
                  </div>
                </button>
              </div>
            </Menu.Button>
          </div>

          <Transition
            as={Fragment}
            enter="transition ease-out duration-100"
            enterFrom="transform opacity-0 scale-95"
            enterTo="transform opacity-100 scale-100"
            leave="transition ease-in duration-75"
            leaveFrom="transform opacity-100 scale-100"
            leaveTo="transform opacity-0 scale-95"
          >
            <Menu.Items className="absolute right-2 top-2 z-[10000] mt-[60px]  origin-top-right rounded-[10px] bg-white ">
              <div className="w-[300px]  bg-[#FEF4E9]  ">
                <div className=" ">
                  <div className="flex justify-end px-4 pt-4">
                    <button
                      id="dropdownButton"
                      data-dropdown-toggle="dropdown"
                      className="inline-block text-gray-500 dark:text-gray-400 hover:bg-gray-100 dark:hover:bg-gray-700 focus:ring-4 focus:outline-none focus:ring-gray-200 dark:focus:ring-gray-700 rounded-lg text-sm p-1.5"
                      type="button"
                    >
                      <span className="sr-only"></span>
                    </button>
                  </div>

                  {/* <!-- Dropdown menu --> */}

                  <div className="flex flex-col items-center justify-center pb-10 bg-[#FEF4E9]">
                    <div className="bg-[#E6E9F7] rounded-[50%] w-8  h-8 flex justify-center items-center -mt-3">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="28"
                        height="28"
                        fill="#000000"
                        viewBox="0 0 256 256"
                      >
                        <path d="M230.92,212c-15.23-26.33-38.7-45.21-66.09-54.16a72,72,0,1,0-73.66,0C63.78,166.78,40.31,185.66,25.08,212a8,8,0,1,0,13.85,8c18.84-32.56,52.14-52,89.07-52s70.23,19.44,89.07,52a8,8,0,1,0,13.85-8ZM72,96a56,56,0,1,1,56,56A56.06,56.06,0,0,1,72,96Z"></path>
                      </svg>
                    </div>
                    <h5 className="mb-3 mt-2 text-xl font-bold text-[black] ">
                      {/* {accessToken?.name} */}
                      {userData?.firstname} {userData?.lastname}
                    </h5>
                    <span className=" text-[#919191] dark:text-gray-400 -mt-2 text-[16px]">
                      {accessToken?.email}
                    </span>

                    {/* View profile */}
                    <Menu.Item>
                      <div
                        className="inline-flex cursor-pointer  items-center px-4 gap-2 py-2 mt-3 text-sm font-medium text-center text-gray-900 bg-white border border-[#F78F1E] rounded-lg hover:bg-[#f78e1ea8]"
                        onClick={() => setUserProfileModal(true)}
                      >
                        <a className="text-[#000] text-[16px]">View Profile</a>
                      </div>
                    </Menu.Item>
                  </div>
                </div>

                <div className="bg-[white]  h-fit  shadow-xl rounded-md pb-3">
                  {(userData?.extension !== "undefined" ||
                    userData?.did !== "undefined") && (
                    <div className="flex w-full text-center  py-5 justify-around items-center">
                      {userData?.extension !== "undefined" && (
                        <div className=" w-1/2">
                          <div className="  text-sm font-medium text-center text-[#888888]">
                            Extension
                          </div>
                          <div className=" text-[#000000] ">
                            {userData?.extension}
                          </div>
                        </div>
                      )}
                      {userData?.did !== "undefined" && (
                        <div className="  border-l-[1px] border-[#ddd] w-1/2">
                          <div className="  text-sm font-medium text-center text-[#888888]">
                            DID
                          </div>
                          <div className=" text-[#000000] ">
                            {userData?.did}
                          </div>
                        </div>
                      )}
                    </div>
                  )}

                  <div className="flex justify-center items-center ml-2 mb-4">
                    <div className="flex justify-center items-center w-[120px] cursor-pointer px-4 gap-2 py-2 mt-6 text-sm font-medium text-center text-gray-900 bg-white rounded-md hover:bg-[#f78e1ea8]">
                      <a
                        className="text-[#AB5D0A] text-[16px]"
                        onClick={handleLogOut}
                      >
                        Logout
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </Menu.Items>
          </Transition>
        </Menu>
      </div>
      {userProfileModal && (
        <UserProfile
          userProfileModal={userProfileModal}
          setUserProfileModal={setUserProfileModal}
        />
      )}
    </div>
  );
};

export default ToolBar;
